module.exports = __webpack_public_path__ + "img/Sunny.075c56cb.png";